"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Url = require("./Rules/Url");

var _Url2 = _interopRequireDefault(_Url);

var _Email = require("./Rules/Email");

var _Email2 = _interopRequireDefault(_Email);

var _Required = require("./Rules/Required");

var _Required2 = _interopRequireDefault(_Required);

var _Phone = require("./Rules/Phone");

var _Phone2 = _interopRequireDefault(_Phone);

var _Min = require("./Rules/Min");

var _Min2 = _interopRequireDefault(_Min);

var _Max = require("./Rules/Max");

var _Max2 = _interopRequireDefault(_Max);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var RulesCollection = function () {
    function RulesCollection(rules) {
        _classCallCheck(this, RulesCollection);

        this.extend(rules);
    }

    _createClass(RulesCollection, [{
        key: "extend",
        value: function extend(rules) {
            for (var key in rules) {
                this[key] = rules[key];
            }
        }
    }, {
        key: "runValidationsAndGetErrors",
        value: function runValidationsAndGetErrors(ruleSet, field) {
            var errors = [];
            var rules = ruleSet.getRulesInField(field.name);

            for (var i in rules) {
                var error = this.makeRule(rules[i], field).validate();

                if (error !== undefined) {
                    errors.push(error);
                }
            }

            return errors;
        }
    }, {
        key: "makeRule",
        value: function makeRule(key, field) {
            var options = void 0;

            var _RulesCollection$spli = RulesCollection.splitKeyFromOptions(key);

            var _RulesCollection$spli2 = _slicedToArray(_RulesCollection$spli, 2);

            key = _RulesCollection$spli2[0];
            options = _RulesCollection$spli2[1];


            return new this[key](field, options);
        }
    }], [{
        key: "splitKeyFromOptions",
        value: function splitKeyFromOptions(key) {
            var options = void 0;
            if (key.indexOf(':')) {
                options = key.split(':');
                key = options.splice(0, 1)[0];
            }
            return [key, options];
        }
    }, {
        key: "default",
        value: function _default() {
            return new this({
                url: _Url2.default,
                email: _Email2.default,
                required: _Required2.default,
                phone: _Phone2.default,
                min: _Min2.default,
                max: _Max2.default
            });
        }
    }]);

    return RulesCollection;
}();

exports.default = RulesCollection;